import React from 'react'
import { lit } from 'src/utils'

export interface LabelProps {
    /**
     * Indicates whether display the label with asterisk.
     */
    required?: boolean
    /**
     *  The copy for the label to display.
     */

    children: string | React.ReactNode
    /**
     * The for attribute of the label.
     */
    htmlFor: string

    /**
     * This allows for dynamic font size of the label -- default is 'text-base' (16px)
     */

    fontSize?: string

    /**
     * The className -- this is mostly used to hook GA event tracking
     * */
    className?: string

    /**
     * This makes it possible to pass through additional props.
     */
    [propName: string]: any
}

export function Label({
    htmlFor,
    fontSize,
    children,
    required,
    className,
    ...rest
}: LabelProps) {
    return (
        <label
            htmlFor={htmlFor}
            {...rest}
            className={lit`block ${fontSize} text-black ${className} mb-1`}
        >
            {`${children}${required ? ' *' : ''}`}
        </label>
    )
}
